import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { inr, num, fmtDate } from "@/lib/format";
import { Loading, Pager, StatusBadge } from "@/components/common/kit";
import DayView from "@/components/common/DayView";

export default function SHistory() {
  const [page, setPage] = useState(1);
  const { data } = useFetch("/closures", { page, limit: 20 });
  if (!data) return <Loading />;
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold tracking-tight">History</h1>
      <div className="space-y-2">
        {data.items.map((c) => (
          <Link key={c.id} to={`/s/history/${c.date}`} className="flex items-center justify-between rounded-md border border-slate-200 bg-white px-4 py-3" data-testid={`history-${c.date}`}>
            <div>
              <p className="font-semibold">{fmtDate(c.date)}</p>
              <p className="font-mono text-xs text-slate-500">{c.totals ? `${num(c.totals.packs_sold)} pks · ${inr(c.totals.sales_value)}` : "Not submitted"}{c.receivable > 0 && ` · Due ${inr(c.receivable)}`}</p>
            </div>
            <div className="flex items-center gap-2"><StatusBadge status={c.status} /><ChevronRight className="h-4 w-4 text-slate-400" /></div>
          </Link>
        ))}
        {data.items.length === 0 && <p className="text-sm text-slate-500">No records yet.</p>}
      </div>
      <Pager page={page} total={data.total} limit={20} onPage={setPage} />
    </div>
  );
}

export function HistoryDay() {
  const { date } = useParams();
  const { salesman } = useAuth();
  const { data } = useFetch(`/day/${salesman.id}/${date}`);
  if (!data) return <Loading />;
  return (
    <div className="space-y-4">
      <Link to="/s/history" className="inline-flex items-center gap-1 text-sm text-slate-500"><ArrowLeft className="h-4 w-4" /> History</Link>
      <div className="flex items-center justify-between"><h1 className="text-xl font-bold">{fmtDate(date)}</h1><StatusBadge status={data.status} /></div>
      <DayView day={data} />
    </div>
  );
}
